<template>
  <div class="card">
    <div class="card-header" v-if="$slots.header">
      <slot name="header"></slot>
    </div>
    <div class="card-body">
      <canvas ref="canvas" :width="width" :height="height"></canvas>
      <div class="center-text">
        <!-- <div>{{ centerText }}</div>
        <div>{{ centerSubText }}</div> -->
        <div>Rs:{{ completionRate }}</div>
      </div>
    </div>
    <div class="card-footer" v-if="$slots.footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true,
    },
    colors: {
      type: Array,
      required: true,
    },
    threshold: {
      type: Number,
      default: 50,
    },
    width: {
      type: Number,
      default: 250,
    },
    height: {
      type: Number,
      default: 305,
    },
    centerText: {
      type: String,
      default: '',
    },
    centerSubText: {
      type: String,
      default: '',
    },
    completionRate: {
      type: Number,
      default: 0,
    },
   
  },
  mounted() {
    this.drawChart();
  },
  methods: {
    drawChart() {
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext('2d');
      const total = this.data.reduce((acc, value) => acc + value, 0);
      let startAngle = -0.5 * Math.PI;
      const centerX = this.width / 2;
      const centerY = this.height / 2;
      const radius = Math.min(this.width, this.height) / 2;
      const innerRadius = radius / 1.5;

      this.data.forEach((value, index) => {
        const sliceAngle = (value / total) * 2 * Math.PI;
        const endAngle = startAngle + sliceAngle;

        // Apply conditional formatting
        const fillColor = value > this.threshold ? '#FF0000' : this.colors[index];

        // Draw the slice
        ctx.beginPath();
        ctx.moveTo(centerX, centerY);
        ctx.arc(centerX, centerY, radius, startAngle, endAngle);
        ctx.closePath();
        ctx.fillStyle = fillColor;
        ctx.fill();

        startAngle = endAngle;
      });

      // Draw the inner circle to make it a donut
      ctx.beginPath();
      ctx.moveTo(centerX, centerY);
      ctx.arc(centerX, centerY, innerRadius, 0, 2 * Math.PI);
      ctx.closePath();
      ctx.fillStyle = '#fff';
      ctx.fill();
    },
  },
};
</script>

<style scoped>
.card-body {
  position: relative;
}
canvas {
  display: block;
  margin: 0 auto;
}
.center-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  font-size: 1.5em;
}
</style>
